import { call, put, takeEvery } from "redux-saga/effects";
import { generic } from "utils/action";
import { authorizedRequest } from "utils/request";
import { setSinglePracticeAction } from "containers/App/actions";
import {
  GET_PRACTICES_ACTION,
  GET_PRACTICES_FAILED_ACTION,
  GET_PRACTICES_SUCCESS_ACTION,
  PRACTICES_URL,
} from "./constants";
import { selectPracticeAction } from "containers/PracticePage/actions";

// Individual exports for testing
export function* getClinicsSaga({ callback }) {
  try {
    const practices = yield call(authorizedRequest, PRACTICES_URL);
    if (practices.length === 1) {
      yield put(setSinglePracticeAction(true));
      yield put(selectPracticeAction(practices[0]));
    } else {
      yield put(setSinglePracticeAction(false));
    }
    yield put(generic(GET_PRACTICES_SUCCESS_ACTION, { practices }));
    yield call(callback, practices.slice());
  } catch (e) {
    yield put(
      generic(GET_PRACTICES_FAILED_ACTION, { reason: e.response.data }),
    );
  }
}

export default function* clinicPageSaga() {
  yield takeEvery(GET_PRACTICES_ACTION, getClinicsSaga);
  // See example in containers/HomePage/saga.js
}
